<template>
  <cfs-drawer
    v-model="isOnlineUsersDrawerOpen"
    fixed
    right
    temporary
    width="600"
    class="shadow-lg border-l border-gray-200"
  >
    <v-list-item class="py-2">
      <v-list-item-content>
        <v-list-item-title class="text-lg font-medium">
          {{ $tc('UsersOnline', onlineUsers.length, { count: onlineUsers.length }) }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list>
      <v-list-item
        v-for="user in onlineUsers"
        :key="user.id"
        class="px-8 py-2 hover:bg-red-50 transition-colors duration-200"
      >
        <v-list-item-icon class="mr-4">
          <v-avatar color="#E0726E" size="38" class="border-2 border-white shadow">
            <v-img v-if="user.image" :src="user.image"></v-img>
            <span v-else class="text-white">{{ getInitials(user.displayName) }}</span>
          </v-avatar>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="flex flex-col gap-y-0.5">
            <span class="text-body-2 font-medium">{{ user.displayName }}</span>
            <span class="text-body-2 text-gray-500">{{ user.email }}</span>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action class="text-gray-600 text-sm italic">
          {{ user.title }}
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </cfs-drawer>
</template>

<script lang="ts">
import { useOnlineStore } from '@/store/modules/useOnlineStore';
import { storeToRefs } from 'pinia';
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'OnlineUsersDrawer',
  setup() {
    const onlineStore = useOnlineStore();
    const { onlineUsers, onlineUsersCount, isOnlineUsersDrawerOpen } = storeToRefs(onlineStore);

    const validOnlineUsers = computed(() => {
      return onlineUsers.value.filter((user) => user && user.id);
    });

    function getInitials(name: string) {
      return name
        .split(' ')
        .map((n) => n[0])
        .join('');
    }

    return {
      onlineUsers: validOnlineUsers,
      onlineUsersCount,
      isOnlineUsersDrawerOpen,
      getInitials,
    };
  },
});
</script>
